// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  contact: '/contact-us',
  page404: '/404',
  page500: '/500'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    dashboard: path(ROOTS_DASHBOARD, ''),
    app: path(ROOTS_DASHBOARD, '/app')
  },
  utilisateurs: path(ROOTS_DASHBOARD, '/utilisateurs'),
  livraisons: path(ROOTS_DASHBOARD, '/livraisons'),
  rapport: path(ROOTS_DASHBOARD, '/rapport'),
  gestionlivraisons: path(ROOTS_DASHBOARD, '/gestionlivraisons'),
  gestioncategories: path(ROOTS_DASHBOARD, '/gestioncategories'),
  infographie: path(ROOTS_DASHBOARD, '/infographie'),
  clients: {
    root: path(ROOTS_DASHBOARD, '/clients'),
    detail: path(ROOTS_DASHBOARD, '/clients/:numero')
  },
  articles: {
    root: path(ROOTS_DASHBOARD, '/articles'),
    detail: path(ROOTS_DASHBOARD, '/articles/:numero')
  },
  commandes: {
    root: path(ROOTS_DASHBOARD, '/commandes'),
    detail: path(ROOTS_DASHBOARD, '/commandes/:numero')
  }
};

export const PATH_DOCS = 'https://candyde.click/';
